/* jednoducha funkce pro selectovani elementu

selector - klasicky selector ('.nejaka-class')
contect - ve vychozim stavu document, pripadne jiny DOM element
multiple - prepinac mezi querySelector a querySelectorAll

*/

let selectorFunction = function(selector, context, multiple) {
  if (context) {
    if (multiple) {
      return Array.prototype.slice.call(context.querySelectorAll(selector));
    }

    return context.querySelector(selector);
  }

  return (multiple ? [] : null);
};

export function querySelectorId(id) {
  return document.getElementById(id);
}

export function querySelector(selector, context = document) {
  return selectorFunction(selector, context, false);
}

export function querySelectorAll(selector, context = document) {
  return selectorFunction(selector, context, true);
}
